module.exports = {
	"user_menu": {
		"user": "Bruger",
		"authenticate": "Log ind",
		"create": "Opret bruger",
		"switch": {
			"title": "Skift bruger",
			"choose": "Vælg bruger",
			"description": "Da der er flere brugere tilknyttet denne konto, kan du her vælge hvilken bruger, du vil være logget ind som.",
			"to": "Skift til valgte bruger"
		},
		"items": {
			"my_page": "Min side",
			"my_documents": "Mine dokumenter",
			"create_document": "Opret dokument",
			"offer": "Mit tilbud",
			"profile": "Mine oplysninger",
			"logout": "Log ud",
			"switch": "Skift bruger"
		}
	}
};